import i18n from 'i18next';
import ICU from 'i18next-icu';
import { initReactI18next } from 'react-i18next';

import commonEn from '../locales/en/common.json';
import glossaryEn from '../locales/en/glossary.json';
import translationEn from '../locales/en/translation.json';
import commonEs from '../locales/es/common.json';
import glossaryEs from '../locales/es/glossary.json';
import translationEs from '../locales/es/translation.json';

export const I18N_PLACEHOLDER = '__placeholder__';
export const DEFAULT_LANGUAGE = 'en';
export const SUPPORTED_LANGUAGES = ['en', 'es'];
export const X_DC_LANG_HEADER = 'x-dc-lang';

export const resources = {
  en: {
    common: commonEn,
    glossary: glossaryEn,
    translation: translationEn,
  },
  es: {
    common: commonEs,
    glossary: glossaryEs,
    translation: translationEs,
  },
};

export const languagePathRegex = new RegExp('/[a-z]{2}/');

export const getUrlWithLanguage = (url: string, language: string): string => {
  return language === DEFAULT_LANGUAGE ? url : `${url}/${language}`;
};

export const initializeI18n = (language: string) => {
  return i18n
    .use(ICU)
    .use(initReactI18next)
    .init({
      lng: language,
      fallbackLng: DEFAULT_LANGUAGE,
      interpolation: {
        escapeValue: false,
      },
      resources,
      returnNull: false,
    });
};

export default i18n;
